import { generateId } from '@freelancer/datastore/testing/helpers';
import type {
  TransactionCurrency,
  TransactionRole,
  TransactionStage,
  TransactionState,
  TransactionType,
} from './search-transactions.backend-model';
import type {
  SearchTransaction,
  SearchTransactionActionsByParty,
  SearchTransactionActionsList,
} from './search-transactions.model';

export interface GenerateSearchTransactionOptions {
  readonly id?: number;
  readonly action?: string;
  readonly actionsByParty?: SearchTransactionActionsByParty;
  readonly actionRequiredParties?: readonly TransactionRole[];
  readonly closeDate?: number;
  readonly currency?: TransactionCurrency;
  readonly description?: string;
  readonly initiationDate?: number;
  readonly isAwaitingDisbursementInfo?: boolean;
  readonly isDraft?: boolean;
  readonly isInConcierge?: boolean;
  readonly isInDispute?: boolean;
  readonly isOffer?: boolean;
  readonly role?: TransactionRole;
  readonly stage?: TransactionStage;
  readonly state?: TransactionState;
  readonly token?: string;
  readonly total?: number;
  readonly transactionType?: TransactionType;
}

export function generateSearchTransaction({
  id = generateId(),
  action,
  actionRequiredParties = [],
  actionsByParty = { buyer: requiredAction('funds') },
  closeDate,
  currency = 'USD',
  description = `Transaction #${id}`,
  initiationDate = Date.now(),
  isAwaitingDisbursementInfo = false,
  isDraft = false,
  isInConcierge = false,
  isInDispute = false,
  isOffer = false,
  role = 'buyer',
  stage = 'awaiting_payment',
  state = 'outstanding',
  token,
  total = 1000,
  transactionType = 'domain_name',
}: Partial<GenerateSearchTransactionOptions> = {}): SearchTransaction {
  return {
    id,
    action,
    actionRequiredParties,
    actionsByParty,
    closeDate,
    currency,
    description,
    initiationDate,
    isAwaitingDisbursementInfo,
    isDraft,
    isInConcierge,
    isInDispute,
    isOffer,
    role,
    stage,
    state,
    token,
    total,
    transactionType,
  };
}

function requiredAction(
  actionType: keyof SearchTransactionActionsList,
): SearchTransactionActionsList {
  return {
    [actionType]: {
      status: 'REQUIRED',
    },
  };
}
